<mat-toolbar color="primary">
  {{ 'scheduler.setup.home.title' | translate }}
</mat-toolbar>

<div class="card-container">
  <div class="card-grid">
    <a [routerLink]="['../skills']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-wrench fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.skills.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.skills.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../skillProfiles']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-object-group fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.skillProfiles.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.skillProfiles.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../zones']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-street-view fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.zones.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.zones.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../schedules']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-tasks fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.schedules.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.schedules.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../visits']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="far fa-people-carry fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.visits.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.visits.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../priorities']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-exclamation-circle fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.priorities.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.priorities.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../planningSegments']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-clock fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.planningSegments.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.planningSegments.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>
  </div>
</div>

<hr />

<div class="card-container">
  <h3>People</h3>
  <div class="card-grid">
    <a [routerLink]="['../resources']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-user fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.resources.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.resources.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../planners']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-calendar-alt fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.planners.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.planners.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../teams']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-users fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.teams.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.teams.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>
  </div>
</div>

<hr />

<div class="card-container">
  <h3>Codes</h3>
  <div class="card-grid">
    <a [routerLink]="['../availabilityCodes']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-calendar-times fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.availabilityCode.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.availabilityCode.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../ticketCompletionCodes']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-theater-masks fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.ticketCompletionCodes.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.ticketCompletionCodes.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>
  </div>
</div>

<hr />

<div class="card-container">
  <h3>System</h3>
  <div class="card-grid">
    <a [routerLink]="['../systemConfigs']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-cog fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.system.configs.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.system.configs.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>

    <a [routerLink]="['../webhooks']" routerLinkActive="active">
      <mat-card [ngClass]="routeAnimationsElements">
        <mat-card-header>
          <i class="fas fa-anchor fa-2x" mat-card-avatar></i>
          <mat-card-title>{{ 'scheduler.setup.webhooks.title' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'scheduler.setup.webhooks.description' | translate }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </a>
  </div>
</div>